import Reveal from "./Reveal";
import { ACCREDITATIONS, PAYMENTS } from "@/config/clinicConfig";

export default function Accreditations() {
  return (
    <section data-testid="accreditations" className="bg-white pt-8 pb-16 lg:pt-10 lg:pb-20">
      <div className="mx-auto max-w-6xl px-5 lg:px-8">
        <Reveal>
          <h2 className="text-center font-display text-3xl font-medium tracking-tight text-espresso sm:text-4xl lg:text-[2.75rem]">
            Accreditations &amp; affiliations
          </h2>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-x-10 gap-y-6">
            {ACCREDITATIONS.items.map((item) =>
              item.dark ? (
                <div
                  key={item.id}
                  data-testid={`accreditation-${item.id}`}
                  className="flex h-20 w-20 items-center justify-center rounded-2xl bg-espresso p-2.5"
                >
                  <img src={item.image} alt={item.alt} loading="lazy" className="max-h-full w-auto object-contain" />
                </div>
              ) : (
                <img
                  key={item.id}
                  data-testid={`accreditation-${item.id}`}
                  src={item.image}
                  alt={item.alt}
                  loading="lazy"
                  className="h-20 w-32 object-contain"
                />
              )
            )}
          </div>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-3" data-testid="accepted-cards">
            {PAYMENTS.cards.map((c) => (
              <img
                key={c.id}
                data-testid={`payment-card-${c.id}`}
                src={c.image}
                alt={c.alt}
                loading="lazy"
                className="h-9 w-auto rounded-md border border-espresso/10 bg-card shadow-sm"
              />
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
